




























import { Component, Vue } from 'vue-property-decorator';
import PublicLayout from '@/views/layouts/PublicLayout.vue';

@Component({
  components: { PublicLayout }
})
export default class Developers extends Vue {
  get developers ():any {
    return [
      {
        name: 'Іван',
        last_name: 'Другак',
        photo: 'language',
        nickname: 'Atick',
        text: 'Backend/Web (php/js) розробник',
        date_of_birth: '1995-04',
        alias: 'developers.atick'
      },
      {
        name: 'Тетяна',
        last_name: 'Другак',
        photo: 'android',
        nickname: 'Atick',
        text: 'Android (Java/Kotlin) розробник розробник',
        date_of_birth: '1996-07',
        alias: 'developers.sun_girl'
      }
    ];
  }
}
